import {getGlobalTenant} from "../services/globalTenant"
import regionService from "../services/region"

/**
 * @description: Helper function to get region.
 * This will always request globalTenant but will resolve instantly if we have a locally stored region first.
 */
export default function getRegion(subdomain: string) {
  const load = getGlobalTenant(subdomain).then((tenant) => {
    regionService.set(tenant.region)
    regionService.setGlobalTenant(tenant)
  })
  const region = regionService.get()
  if (region) {
    return Promise.resolve()
  }

  return load
}
